import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { NavLink, Outlet } from "react-router-dom";

export default function MainLayout() {
  return (
    <>
      <AppBar position="sticky">
        <Toolbar>
          <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>
            MarriageBiodata.live
          </Typography>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button component={NavLink} to="/" color="inherit">
              Home
            </Button>
            <Button component={NavLink} to="/create-biodata" color="inherit">
              Create Biodata
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2 }}>
        <Outlet />
      </Box>
    </>
  );
}
